import React, { useState } from "react";
import PropTypes from "prop-types";
import Image from "@root/components/image";
import { ReactComponent as Quote } from "assets/svgs/manrope-quote.svg";
import { ReactComponent as PlayButton } from "assets/svgs/play-button.svg";
import ResponsiveWrapper from "../_responsive-wrapper";
import VideoLightbox from "../video-lightbox";

const GridTable = ({ items }) => {
    const [selectedVideo, setSelectedVideo] = useState(null);

    const handleVideoClick = (video) => setSelectedVideo(video);
    const handleCloseVideo = () => setSelectedVideo(null);
    const handleKeyDown = (event, video) => {
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            handleVideoClick(video);
        }
    };

    return (
        <>
            <ResponsiveWrapper className="grid-table">
                <div className="grid-table__inner">
                    {items.map((item, index) => {
                        const total = items.length;
                        const isFirst = index === 0;
                        const isLast = index === total - 1 && total % 2 === 0;

                        const gridItemClass = [
                            "grid-table__item",
                            (isFirst || isLast) && "grid-table__item--wide",
                        ]
                            .filter(Boolean)
                            .join(" ");

                        const colSpan = item.colSpan ? { "--col-span": item.colSpan } : {};
                        return item.video ? (
                            <button
                                key={`grid-item-${item.text}`}
                                className={gridItemClass}
                                style={colSpan}
                                onClick={() => handleVideoClick(item.video)}
                                onKeyDown={(event) => handleKeyDown(event, item.video)}
                                type="button"
                            >
                                <div className="grid-table__desktop-play-button">
                                    <div className="grid-table__desktop-play-button--triangle" />
                                </div>
                                <div className="grid-table__image">
                                    <Image lazyLoad={false} image={item.image} className="grid-table__image-tag" />
                                </div>
                                <div className="grid-table__item-content">
                                    <Quote className="grid-table__quote" />
                                    <PlayButton className="grid-table__mobile-play-button" />
                                    <div className="grid-table__text">
                                        {item.text}
                                    </div>
                                </div>
                            </button>
                        ) : (
                            <div
                                key={`grid-item-${item.text}`}
                                className="grid-table__item"
                                style={colSpan}
                            >
                                <div className="grid-table__image">
                                    <Image lazyLoad={false} image={item.image} className="grid-table__image-tag" />
                                </div>
                                <div className="grid-table__item-content">
                                    <Quote className="grid-table__quote" />
                                    <div className="grid-table__text">
                                        {item.text}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </ResponsiveWrapper>
            <VideoLightbox video={selectedVideo} onClose={handleCloseVideo} />
        </>
    );
};

GridTable.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            colSpan: (props, propName, componentName) => {
                const value = props[propName];
                if (value !== undefined && !Number.isInteger(value)) {
                    return new Error(
                        `Invalid prop \`${propName}\` supplied to \`${componentName}\`. Expected an integer.`,
                    );
                }
                return null;
            },
        }),
    ).isRequired,
};

export default GridTable;
